//original
//needed - run on initial page load
// done - scrolling event handling
// account for more than one product option
// make this work for all products, currently the form is hard coded to 1 product
//remove testing mode and turn into IIFE
//brand new comment

let queryString1 = window.location.search;
let urlParams1 = new URLSearchParams(queryString1);
let testing_mode = urlParams1.get('testing-mode');

let text_strings = document.querySelector(`#bh-app-text-strings`).innerText;
let    {bh_app_text_strings}= JSON.parse(text_strings);
    text_strings = bh_app_text_strings;
let ATCButton = document.querySelector('product-info[id^="ProductInfo-template"] [name="add"]');
let formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencyDisplay: 'narrowSymbol'});
let elements_to_callbacks = [];
let all_swatches = Array.from ( document.querySelectorAll('img[data-variant-id].swatch') );
let variants = JSON.parse( document.querySelector('script#variant-data').text );
let variant_groups = JSON.parse( document.querySelector('script#variant-groups').text );
let color_option_index = JSON.parse( document.querySelector('script#color-option-index').text ).color_option_index;
let ATCButtonText = ATCButton.querySelector('span');
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
let initial_swatch = document.querySelector(`img[data-variant-id="${urlParams.get('variant')}"]`);
let color_groups = [];
let color_groups_display_order = text_strings.color_groups_labels_order;
let variant_selector = document.querySelector('select[name="options[Color]"]');
let variant_selector_wrapper = document.querySelector('variant-selects');
let getURLParams = (param='') =>{
  const queryString = window.location.search;
 
  const urlParams = new URLSearchParams(queryString);

  
  return urlParams.get(param);
}
let clearance_percent_messaging = [{percent_off:40,message:"CLEARANCE UP TO 50% OFF",default:true},{percent_off:50,message: "CLEARANCE UP TO 50% OFF"}];

let bh_app_strings = document.querySelector(`#bh-app-text-strings`).textContent;
bh_app_strings = JSON.parse(bh_app_strings);

let sold_out_marker = 'https://cdn.shopify.com/s/files/1/1410/9094/files/transparent-not-there.png?v=1613796546';
let floating_atc;

/* Sticky-add-to-cart: elements */
let stickyATC = document.getElementById('sticky-atc');
let stickyATCImage = stickyATC.querySelector('#sticky-atc-image');
let stickyATCColors = stickyATC.querySelectorAll('.sticky-atc-color');
let stickyATCButton = stickyATC.querySelector('#sticky-atc-ProductSubmitButton');
let stickyATCButtonText = stickyATCButton.querySelector('span');
let stickyATCPropertyInput = document.querySelector('#property_stickyatc');

/* Preorder: elements */
let preorderData = JSON.parse(document.querySelector('script#preorder-data')?.text?.trim() ?? '{"eta_variants": [], "eta_messages": {}}');

['click','change','slideChanged'].forEach(event_type =>{


document.addEventListener(event_type,function(e){
    
    let elems = elements_to_callbacks.filter(elem => { if(e.target.matches( elem.element_selector)){ return elem }  });
    
    elems.forEach((el) => 
        {
          
            if(e.target.matches(el.element_selector) && event_type == el.event_type ) {
                try{
                    
                    el.callback(e.target,e)
                    
                }catch(error){
                    console.log(error);
                }
            }
        }
        );
    
        
});
    
});


function findVariantIDInGroups(variant_id){
        let group_name = null;
    let groups = Object.entries(variant_groups.datasets);

    // Preorder: Group
    if (preorderData?.eta_variants.length) {
        groups.push(['pre_order', preorderData.eta_variants]);
    }

    let [group] = groups.filter(group => {

        let [group_name,variants] = group;
        return variants.includes(parseInt(variant_id));

        
    });
        if(group){

            [group_name] = group;    
        }
        
        
        return group_name;
}




function disableATCButton(){
  ATCButton.setAttribute('disabled',true);
  stickyATCButton.setAttribute('disabled',true);
}

function enableATCbutton(){
  ATCButton.removeAttribute('disabled');
  stickyATCButton.removeAttribute('disabled');
}


function updateATCButtonText(target,event,message=null){
    
    if(message){

        setTimeout(function() {
          ATCButtonText.textContent = message;
          stickyATCButtonText.textContent = message;
        }, 600);

    }else{

        
        let groups_to_messages = [];
        groups_to_messages['pre_launch'] = "Coming Soon";
        groups_to_messages['unavailable'] = "Sold Out";

        // Preorder: Atc message
        groups_to_messages['pre_order'] = "Add to cart (Pre-Order)";

        let current_swatch = getCurrentSwatch(target);

        let variant_id = current_swatch.dataset.variantId;

        let group_name= findVariantIDInGroups(variant_id);
    

        if(Object.keys(groups_to_messages).includes(group_name)){
                
                if(groups_to_messages.hasOwnProperty(group_name)){
 
                  setTimeout( function(){
                    if(group_name === "pre_launch"){
                        disableATCButton();
                    }
                    const buttonText = groups_to_messages[group_name];
                      
                    ATCButtonText.textContent = buttonText;
                    stickyATCButtonText.textContent = buttonText;
                  }, 600);
                   
                }

        } else {
              
                setTimeout( function(){
                  const buttonText = "Add to cart";

                  ATCButtonText.textContent = buttonText;
                  stickyATCButtonText.textContent = buttonText;
                }, 600);
                   
        }
  
    }
    
}

function getCurrentSwatch(target){
    let current_swatch;
    if( target.matches('img[data-variant-id]') ){
        current_swatch = document.querySelector(`img[data-variant-id="${target.dataset.variantId}"]`);

    }
    else if(target.matches(`select[name="options[Color]"]`)){
    
    current_swatch_color = target.value;
    current_swatch_info = getVariantWith('color',current_swatch_color);
    current_swatch = document.querySelector(`img[data-variant-id="${current_swatch_info.id}"]`);
    
    }

    return current_swatch;
}
function getVariantWith(type,search_for){
    

    
    let [find] = variants.filter(variant => {
        
        if(type=='variant_id'){
            return variant.id == search_for
        }else if(type=='color'){

                let title_parts = variant.title.split(' / ');
                return title_parts.includes(search_for);

        }
    });
    
        return find;
    }
    
function updateVariantParameter(variant_id){

var queryParams = new URLSearchParams(window.location.search);
queryParams.set("variant", variant_id.toString());
history.replaceState(null, null, "?"+queryParams.toString());

}

function updateSelector (target){

    let variant_id_to_find = target.dataset.variantId;

    
    let option_to_select = variants.filter(variant => variant.id == variant_id_to_find).map(variant => variant[color_option_index]);
    variant_selector.value=option_to_select;
    variant_selector_wrapper.dispatchEvent(new Event('change'));
    updateVariantParameter(variant_id_to_find);
    
}

function highlightCurrentSwatch(target){
    let current_swatch = getCurrentSwatch(target);
    
  

    
    Array.from( all_swatches ).forEach(x => { x.style.border = '1px solid transparent'; x.classList.remove('selected-swatch')});
    
    current_swatch.style.border = '1px solid #c41949' 
    current_swatch.classList.add('selected-swatch');
}


function showOOSForm(target){   
     target = getCurrentSwatch(target);
    function updateOOSForm(form,target){

                    let buttons = Array.from(form.querySelectorAll('.esc-btn'));
                    const msg = {sms:"Thank you - we'll send you an SMS when your item becomes available",email:"Thank you - we'll send you an email when your item becomes available"}
                     let variant = getVariantWith('variant_id',target.dataset.variantId);
                     let color = ''; 
                    if(variant){
                        color = variant.title;
                     }
                     let title = form.querySelector('.esc-out-of-stock-title');
                    
                    title.textContent = title.textContent.replace('This color', `This color ${color},`);
                    buttons.forEach(button => {
                                    const kind = button.dataset.alertType;
                                    
                        
                                                
                            const product_variant_id = target.dataset.variantId;
                                    


                        
                            button.addEventListener('click',function(e){
                                
                                            const input = document.querySelector(`input[name=${kind}]`);
                                            const destination = input.value;           

                                
                                            Array.from(document.querySelectorAll('.back-in-stock-warning')).forEach(warning => warning.remove());
                                            

                                            if(destination !== ""){
                                                    var xhr = new XMLHttpRequest;
                                                    xhr.open('POST', 'https://wigscom-ims.herokuapp.com/alerts', true);
                                                    xhr.setRequestHeader('Content-Type','application/x-www-form-urlencoded; charset=UTF-8');
                                                    xhr.send(   `alert%5Bproduct_variant_id%5D=${product_variant_id}&alert%5Bdestination%5D=${destination}&alert%5Bkind%5D=${kind}`) ;
                                                    const msg = {sms:"Thank you - we'll send you an SMS when your item becomes available",email:"Thank you - we'll send you an email when your item becomes available"}
                                                    let msg_elm = document.createElement('div');
                                                    msg_elm.innerHTML = `<span>${msg[kind]}</span>`;
                                                    e.currentTarget.remove();
                                                    input.parentNode.replaceChild(msg_elm,input);
                                                
                                            }else{
                                                
                                                    const warning_text = {sms:"Please enter a valid phone number",email:"Please enter a valid email address"}
                                                    input.parentElement.insertAdjacentHTML('afterend',`<p class='back-in-stock-warning'><span> ${warning_text[kind]}</span></p>`);
                                                                                                  
                                            }      
                                
                            });
                    
                    });

        return form;

                
    }
   
    
    let current_oos_form = document.querySelector('#esc-oos-form');
    if(current_oos_form){
        current_oos_form.remove();
    }

    let unavailable_ids = variant_groups.datasets.unavailable;


    // Preorder: Out of stock form
    let preorder_ids = preorderData.eta_variants;

     if (preorder_ids.includes(parseInt( target.dataset.variantId))) {
        let new_oos_form = document.querySelector('#oos-form-template').content.cloneNode(true);
        new_oos_form = updateOOSForm(new_oos_form,target);
        
        document.querySelector("div:has(> product-form)").after(new_oos_form);
     }
     else if(unavailable_ids.includes( parseInt( target.dataset.variantId) ) ){
     
        let new_oos_form = document.querySelector('#oos-form-template').content.cloneNode(true);
        new_oos_form = updateOOSForm(new_oos_form,target);  
        
        variant_selector_wrapper.after(new_oos_form);
     }

}









function detectSingleVariants(){
  if(variants.length === 1){

        
            showOOSForm(all_swatches[0]);
       
  }

}




function initSwatchDividers(){
    
    let swatch_container = document.querySelector('#swatch-container');

    const group_settings = [,
        {
            group_name:"exclusive-color",
            group_display_image:"https://cdn.shopify.com/s/files/1/1410/9094/files/ProductPage_Dividers-LE-room.jpg?v=1740772726",
        },
        {
            group_name:"new_colors",
            group_display_image:"https://cdn.shopify.com/s/files/1/1410/9094/files/ProductPage_Dividers-new.jpg?v=1713556013",
        },
        {
                group_name: "limited_off",
                group_display_image: "https://cdn.shopify.com/s/files/1/1410/9094/files/ProductPage_Dividers-LPD.png?v=1759779850",         
        },
        {
            group_name:"pre_launch",
            group_display_image:"https://cdn.shopify.com/s/files/1/1410/9094/files/ProductPage_Dividers-new.jpg?v=1713556013",
        },
        {
            group_name: "pre_order",
            group_display_image: "https://cdn.shopify.com/s/files/1/1410/9094/files/ProductPage_Dividers-preorder.png?v=1776283572",
        },
        {
            group_name:"unavailable",
            group_display_image:"https://cdn.shopify.com/s/files/1/1410/9094/files/ProductPage_Dividers-backsoon.jpg?v=1713556013",
        }
    ];

    // Exclusive Colors: [ARABIAN-SAND]
    variant_groups = {datasets: {...variant_groups.datasets, "exclusive-color": [42854630817903, 44042863214703, 52747170447471]}};

    // Limited Time Offer: [Crowd Pleaser - RL8/29]
    variant_groups = {datasets: {...variant_groups.datasets, "limited_off": []}};

    // Preorder: Divider group
    variant_groups = {datasets: {...variant_groups.datasets, "pre_order": preorderData.eta_variants}};
    variant_groups = {datasets:  {...variant_groups.datasets, "unavailable": variant_groups.datasets["unavailable"]?.filter((v) => !preorderData.eta_variants.includes(v)) ?? []}};

    group_settings.forEach(group_setting => {
        
            
        
            let figures = all_swatches.filter( swatch => variant_groups.datasets[group_setting.group_name].includes(parseInt( swatch.dataset.variantId) ) ).map(swatch => swatch.closest('figure'))
            if(figures.length > 0){
                let divider = `<figure>                           
                        <div style="position: relative">
                            <img src="${group_setting.group_display_image}" class='gallery-separator' height="74" width="57" class="swatch">
                            </div>
                        </figure>`;
                swatch_container.insertAdjacentHTML('beforeend',divider);
                figures.forEach(figure => swatch_container.append(figure));
            }    
        
        
    });
    
}



function initClearanceSection(){

        
            let clearance_message = clearance_percent_messaging.find(x => x.default === true);    
            let clearance_percent_discount_swatches = all_swatches.filter(swatch => variant_groups.datasets.clearance_percent_discount.includes( parseInt( swatch.dataset.variantId) ) );
        
            if(clearance_percent_discount_swatches.length > 0){
                  clearance_message = clearance_percent_messaging.find(x => x.percent_off === 50);
                
              
            }
  
            let clearance_swatches = all_swatches.filter(swatch => variant_groups.datasets.on_clearance.includes( parseInt( swatch.dataset.variantId) ) );
            
            if(clearance_swatches.length > 0){
                let figures = clearance_swatches.map(c_swatch => c_swatch.closest('figure'));

              let vendor = meta.product.vendor; 
              let clearanceExtra = ""
              if (vendor === "Raquel Welch" || vendor === "Gabor" || vendor === "Hairdo" || vendor === "HIM" || vendor === "Kim Kimble") {
                let productDescription = document.querySelector(".product__description");
                clearanceExtra = "Clearance colors indicate open box items."
                productDescription.insertAdjacentHTML('afterend',`<div style="margin: 1rem 0; display: block" id="special_text"><span style="font-weight: bold"> Clearance Sale: </span>
         Clearance colors indicate open box items, backed by the <a href="https://www.wigs.com/" style="text-decoration: underline;">Wigs.com</a> quality assurance. We gladly accept return of all eligible clearance products no later than 45 days from the original ship date with $0 restocking fees. Read our store <a href="https://www.wigs.com/apps/help-center#hc-return-policy" style="text-decoration: underline;">policies</a> for the full details.
         </div>`)
              }



                let swatch_container = document.querySelector('#swatch-container');
                swatch_container.insertAdjacentHTML('afterend',
                                                    `
                                                    <div class="clearance-div-divider"><br/></div>
                                                    <div class="clearance-container">
                                                    <span class="clearance-text">${clearance_message.message}</span>
                                                    <span id='clearance-swatch-pricing' class="clearance-price"> </span>
                                                    <span> Colors below!</span>
                                                    <div style="font-size: 1.2rem">${clearanceExtra}</div>
                                                    <div id="clearance-swatches">
                                                    </div>
                                                    </div>                                                  
                                                    `);

                figures.forEach(c_swatch  => document.querySelector('#clearance-swatches').append(c_swatch) );

                //  let clearance_container = document.querySelector('#clearance-swatches');
                //  let bfcmClearanceVariantIDs= figures.map(figure => Number( figure.querySelector('img').dataset.variantId) ).filter(n => n  ).filter(v_id => variant_groups.datasets.bfcm.includes(v_id));
                //  let bfcmClearanceVariantSwatches = figures.filter(figure => { let v_id = Number( figure.querySelector('img').dataset.variantId); return bfcmClearanceVariantIDs.includes(v_id) } );

                    
                //      if(bfcmClearanceVariantIDs.length > 0){

                //                     bfcmClearanceVariantSwatches.forEach(swatch => clearance_container.append(swatch));
                //                     let bfcmSeparator = document.querySelector('figure div img.gallery-separator[src*="bfcm"]').closest('figure');
                //                     bfcmClearanceVariantSwatches[0].closest('figure').insertAdjacentElement('beforebegin',bfcmSeparator);
                //      }
            }

}

function initBlendSection() {            
    let blend_message = {
        message: bh_app_text_strings.blend_section_messaging,
        subtext: bh_app_text_strings.blend_section_subtext
    };

    let blend_ids = [42862285586543, 42862286798959, 42875029586031, 42862282080367, 8010630266991, 44061934026863, 44061934649455, 44061934682223, 44061934714991, 44531127976047, 44531128008815, 44531128041583, 44531128631407, 44531128664175, 44531128696943];
    let blend_swatches = all_swatches.filter((swatch) => blend_ids.includes( parseInt( swatch.dataset.variantId) ));
    
    if (blend_swatches.length > 0) {
        let figures = blend_swatches.map((b_swatch) => b_swatch.closest('figure'));

        let swatch_container = document.querySelector('#swatch-container');
        swatch_container.insertAdjacentHTML('afterend',
        `
            <div class="blend-container">
                <div class="blend-text">
                    ${blend_message.message}
                    <a class="blend-link" href="https://www.wigs.com/blogs/news/jon-renau-launches-ignite-human-hair">(${bh_app_text_strings.blend_section_blend_link_text})</a>
                </div>
                <div class="blend-subtext">
                    ${blend_message.subtext}
                </div>
                <div id="blend-swatches">
                </div>
            </div>                                                  
        `);

        figures.forEach((b_swatch)  => document.querySelector('#blend-swatches').append(b_swatch));
    }
}

function createColorGroups(){
    
    const color_group_data = JSON.parse( document.querySelector('#color-group-data').textContent );
    const color_names =    Object.keys( color_group_data ).sort(function(a, b){return a - b});
    
    
    color_names.forEach(color_name => {
        
            if(getVariantWith('color',color_name)){
                
                if(!color_groups.hasOwnProperty(color_group_data[color_name]))  color_groups[color_group_data[color_name]] = [];
                
            
                color_groups[color_group_data[color_name]].push(getVariantWith('color',color_name).id);
                
            }        
    
    })
    
    
    
    color_groups.new_colors = variant_groups.datasets.new_colors;
    
    
    let color_groups_container=document.createDocumentFragment();
    let color_groups_list = document.createElement('ul');
     color_groups_list.id = 'color-groups';
    
    color_groups_display_order.forEach(order => {
    
        if( color_groups.hasOwnProperty(order) ){
            if(color_groups[order].length > 0){
            let li = document.createElement('li');
            let text = order.replace(/[-_]/g,' ');
            text = text[0].toUpperCase() + text.slice(1);
            let link = document.createElement('a');
            link.href="#";
            link.textContent = text;
            link.setAttribute('data-color-group',order);
            li.appendChild(link);
            color_groups_list.append(li);
            }
        }
    
        color_groups_container.append(color_groups_list);
        
    
    
        
        
    });
    if(color_groups_list.childElementCount > 0){

        color_groups_list.insertAdjacentHTML('afterbegin',`<li><a href="#" data-color-group="all">All</a></li>`);
        document.querySelector('#swatch-container').before(color_groups_container);
    }

    
}
    
function colorGroupHandler(target,event){
    
        
    event.preventDefault();

    let allGroupsLinks = document.querySelectorAll("#color-groups li a");
    
    allGroupsLinks.forEach((link) => {
        link.classList.remove("active");
    });

    target.classList.add("active");

    let color_group_name = target.dataset.colorGroup;

    let variants_in_group = []; 
    
    
    if(color_groups.hasOwnProperty(color_group_name)){
        
        variants_in_group = color_groups[color_group_name];
            
     }
    
    all_figures = Array.from( document.querySelectorAll('#swatch-container figure, #clearance-swatches figure, #blend-swatches figure'));
    all_figures.forEach(figure =>{ 
        
                
                figure.style ='display:inline-block'; 
                if(color_group_name == "all")return;
        
                swatch = figure.querySelector('img.swatch');
                if(!swatch){
                    figure.style ='display:none';
                    return;
                }    
        
        
            if( !variants_in_group.includes(parseInt( swatch.dataset.variantId ) ) ){
                    
                      figure.style ='display:none';
                    
            }
        
    });
    hideShowColorDividers();
    clearVariantSelection();
    
}     

function clearVariantSelection() {
    all_swatches.forEach(swatch => {
        swatch.style.border = '1px solid transparent';
        swatch.classList.remove('selected-swatch');
    });

    variant_selector.value = '';
    variant_selector_wrapper.dispatchEvent(new Event('change'));


    let banner = document.getElementById("high-return-banner");
    if (banner) {
        banner.style.display = 'none';
    }

    disableATCButton();
    updateATCButtonText(null, null, 'Choose a color');
    initDropDownSelector();
    displayMainPriceRange();
  // document.querySelector('.wbpricetax .mainp-price').style.visibility="visible"
}

function hideShowColorDividers(){    
    const dividers = document.querySelectorAll('.gallery-separator');
        dividers.forEach(divider => {
            const parent_figure = divider.parentElement;
            
            const nextSibling = parent_figure.nextElementSibling;
            
          if(nextSibling) {
              
            const nextSibling_swatch = nextSibling.querySelector('img.swatch');
              if(nextSibling_swatch && nextSibling_swatch.closest('figure').style.display !== "none"){
                 divider.closest('figure').style.display="inline-block"; 
              } else {
                divider.closest('figure').style.display="none"; 
              }
          } else{
              divider.closest('figure').style.display="none"; 
          }        
        });
}

function hideShowClearanceSection(){

    let clearance_section = document.querySelector('.clearance-container');
    
    if(clearance_section){
            let figure_display_status =Array.from(  clearance_section.querySelectorAll('figure') ).map(figure => figure.style.display );
            
            if(figure_display_status.every(status => status === 'none')){
                clearance_section.style.visibility='hidden';
            }else{
                clearance_section.style.visibility='visible';
       }
    }


}

function addHTMLTo(selector=null,where='beforeend',new_HTML){

    
    selector = selector === '' ? null : selector;
        
    let element;
    
    if(selector){
    
        element = document.querySelector(selector);
    }
    
    if( element ){
        
        element.insertAdjacentHTML(where,new_HTML);
    }




}
function getPriceRangeString(prices){

    let unique_prices = [... new Set( prices ) ];
  
    if(unique_prices.length > 1 ){

          let unique_prices = [... new Set( prices ) ];
          let min = Math.min(... prices) / 100;
          let max = Math.max(... prices) /100;
          let price_range_string = formatter.format(min) + ` - ` + formatter.format(max);

        return price_range_string;
    }
   else{
      let price = Math.max(...prices) /100;
      
      return formatter.format(price);
    }
      
  
}

function displayMainPriceRange(){
  
    let selector = 'product-info .price-item.price-item--sale.price-item--last';
    let prices = meta.product.variants.map(x => x.price) ;
    let price_range_string = getPriceRangeString(prices);
    if(price_range_string){
        
    
            document.querySelector(selector).textContent = '';
        
        addHTMLTo(selector,'beforeend',`${price_range_string}`);
    }
}

function display30PercentSaleMessage () {
    window.addEventListener('DOMContentLoaded', () => {
        const saleOnElement = document.getElementById('turning-sale-on');

        if (saleOnElement && (meta?.product.vendor != "Estetica" || saleOnElement.dataset.excludeEstetica === "false")) {
            document.querySelector('product-info[id^="ProductInfo-template"]')?.setAttribute('sitewide-sale', 'true');
        }
    })
}

function updateSalePrice (target) {
  
   if (document.getElementById('sale-price-ad')){
     let hideFrom = document.getElementById('span-to-hide');
     let salePriceOption = document.getElementById('sale-price-ad');
     let current_swatch = getCurrentSwatch(target)
      
     let [price=null] = meta.product.variants.filter(variant => variant.id === parseInt( current_swatch.dataset.variantId ) ).map(v => v.price);
      price = returnInCents(price);        
        if(price){
            
          
          salePriceOption.textContent = formatter.format(price * 0.7 /100);
          if (hideFrom) {hideFrom.style.display = "none";}       
          }                  
    }

}

function displayClearancePriceRange(){
  
    let selector = '#clearance-swatch-pricing';
    let prices = meta.product.variants.filter(variant => variant_groups.datasets.on_clearance.includes(variant.id)).map(v => v.price) ;
    if(prices.length > 1){
    let price_range_string = getPriceRangeString(prices);
      if(price_range_string){
          
      
              
          if(selector){
            document.querySelector(selector).textContent = price_range_string;
          }
      }
    }else if(prices.length == 1){
          
      document.querySelector(selector).textContent = formatter.format( prices[0] /100);
      
    }
}


function handleSlideChange(){
    
    // let current_slide = parseInt (document.querySelector('.slider-counter--current').textContent.trim() );
    
    // if( (current_slide !== 1  && !isNaN(current_slide) ) || !getURLParams('variant') ){
        
    //     disableATCButton();
        
    // }else{
        
    //     enableATCbutton()
    // }
    
    
}

function displaySelectedClearancePrice(target){
    let current_swatch = getCurrentSwatch(target);
    let [price=null] = meta.product.variants.filter(variant => variant.id === parseInt( current_swatch.dataset.variantId ) ).map(v => v.price);
    if(price){
          
        if( document.querySelector('#clearance-swatch-pricing') ){

                     document.querySelector('#clearance-swatch-pricing').textContent = formatter.format(price /100);
        }
    }
}

function displaySpecialClearanceVerbiage(target) {
  let vendor = meta.product.vendor; 
  
  if (vendor === "Raquel Welch" || vendor === "Gabor" || vendor === "Hairdo" || vendor === "HIM" || vendor === "Kim Kimble") {  
    let productDescription = document.querySelector(".product__description");
    let clearance_swatches = all_swatches.filter(swatch => variant_groups.datasets.on_clearance.includes( parseInt( swatch.dataset.variantId) ) );
    let clearance_swatches_v_ids = clearance_swatches.map(cs => cs.dataset.variantId)
    let current_swatch = getCurrentSwatch(target);
    let variant_id =  current_swatch.dataset.variantId;
    let clearanceVerbiage = document.querySelector("#special_text")
    
 
    if(clearance_swatches_v_ids.includes( variant_id )){     
        if (!clearanceVerbiage) {
         productDescription.insertAdjacentHTML('afterend',`<div style="margin: 1rem 0; display: block" id="special_text"><span style="font-weight: bold"> Clearance Sale: </span>
         Clearance colors indicate open box items, backed by the <a href="https://www.wigs.com/" style="text-decoration: underline;">Wigs.com</a> quality assurance. We gladly accept return of all eligible clearance products no later than 45 days from the original ship date with $0 restocking fees. Read our store <a href="https://www.wigs.com/apps/help-center#hc-return-policy" style="text-decoration: underline;">policies</a> for the full details.
         </div>`)    
        } else {
          clearanceVerbiage.style.display = "block"
        }
    } else {
      if (clearanceVerbiage) {
        clearanceVerbiage.style.display = "none"
      } else return      
    }    
  } 
}




const initDropDownSelector = () => {

   let selector = document.querySelector('select[name="options[Color]"]');
  
   if(selector){
    let COCoption = selector.querySelector('option[disabled]')
      if (COCoption) {
        COCoption.selected = true;
      } else {
        selector.insertAdjacentHTML('afterbegin',`<option disabled selected>Choose a color</option>`);
      }
   }
}

function handleClearanceLIP(target){
Array.from ( document.querySelectorAll('input.clearance_property')).forEach(lip => lip.remove());
let clearance_swatches = all_swatches.filter(swatch => variant_groups.datasets.on_clearance.includes( parseInt( swatch.dataset.variantId) ) );
let clearance_swatches_v_ids = clearance_swatches.map(cs => cs.dataset.variantId)
let current_swatch = getCurrentSwatch(target);
let variant_id =  current_swatch.dataset.variantId ;    
if(clearance_swatches_v_ids.includes( variant_id )){
    let form = document.querySelector('product-form form[action="/cart/add"]');
    form.insertAdjacentHTML('beforeend',`<input class="clearance_property" type="hidden" name="properties[_sale]" value="clearance">`);   
}
}


function attachSoldOutMarkers(){
all_swatches.forEach(swatch => {
 
      if(swatch.dataset.available == "false"){
  
          swatch.parentElement.insertAdjacentHTML('afterbegin',`<img class='product__media-marker-sold-out' src="${sold_out_marker}">`);
          
      }
  });
  document.querySelectorAll('.product__media-marker-sold-out').forEach( x => {
        x.addEventListener('click',function(e){
            e.target.parentElement.querySelector('img.swatch').click();
        });
  })
}

function displayHighReturnBanner (target) {
   target = getCurrentSwatch(target);
  
  let high_returns_ids = variant_groups.datasets.high_returns;

    let banner = document.getElementById("high-return-banner")
    
     if(high_returns_ids.includes( parseInt( target.dataset.variantId) ) ){
       banner.style.display = 'block'      
     } else {
       banner.style.display = 'none'
     }
}

 function updateFloatingATC(){

  
          //  console.log('updating the floating atc',variant_selector.value);
          // let current_atc_button = document.querySelector(`main#MainContent form[data-type='add-to-cart-form'] button[name='add']`);
           
          // let new_floating_atc_button = current_atc_button.cloneNode(true);
          // new_floating_atc_button.id = 'floating-atc-button';
   
             
          // new_floating_atc_button.setAttribute('form', current_atc_button.closest('form').id);
   
          // let existing_floating_atc_button = floating_atc.querySelector('button');
          // if(!existing_floating_atc_button){
          //     floating_atc.appendChild(new_floating_atc_button)
          // }else{
          //     floating_atc.replaceChild(new_floating_atc_button,existing_floating_atc_button);            
          // }
    
}

function returnInCents(number){

    if(number.toString().includes('.')){

            let new_number = number;
            new_number = new_number.toString().replace('.','');
            number = parseInt(new_number);

        
    }
    return number;
}

// Sticky-add-to-cart: product page functionality

function triggerATCButton() {
    if (stickyATCPropertyInput) {
        stickyATCPropertyInput.value = true;
    }

    ATCButton?.addEventListener('pointerdown', () => {
        stickyATCPropertyInput.value = false;
    }, {once: true});

    ATCButton?.click();
}

function chooseColorScrollEvent() {
    const colorGroups = document.querySelector('[id*="checkout_upsell_app_swatches"]');
    colorGroups?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function activateStickyATCButton() {
    stickyATCButton?.removeEventListener('click', chooseColorScrollEvent);
    stickyATCButton?.addEventListener('click', triggerATCButton);
}

function updateStickyATC(target) {
    const current_swatch = getCurrentSwatch(target);
    const swatch_clone = current_swatch.cloneNode();
    const swatch_variant = meta.product.variants.find((variant) => `${variant.id}` === current_swatch.dataset.variantId);

    swatch_clone.className = '';
    swatch_clone.style.border = '';
    swatch_clone.removeAttribute('data-variant-id');

    stickyATCImage.innerHTML = '';
    stickyATCImage.appendChild(swatch_clone);

    stickyATCColors.forEach((colorElement) => {
        colorElement.innerHTML = swatch_variant.public_title;
    });

    activateStickyATCButton();
}

function updateStickyATCChooseColor() {
    stickyATCButton?.removeAttribute('disabled');
    stickyATCButton?.addEventListener('click', chooseColorScrollEvent);
}

function initStickyATC() {
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach((entry) => {
            if (!entry.isIntersecting && entry.boundingClientRect.y < 0) {
                stickyATC.classList.add('active');
            }
            else {
                stickyATC.classList.remove('active')
            }
        });
    });
    
    observer.observe(ATCButton);
}

// Slide descriptions: variant button functionality

function onClickSlideDescButton(event) {
    const variantButton = event.currentTarget;
    
    variant_selector.value = variantButton.dataset.optionValue;
    variant_selector.dispatchEvent(new Event('change', { bubbles: true }));
}
 
function variantRegexString(variantString) {
    return '(?<!/|-)\\b' + variantString.replaceAll(/(\s?-\s?|\s|\/)/g, '(\\s?-\\s?|\\s|/)').replaceAll('+', '\\+').replace(/.+\b/, '$&\\b(?!/|"|\\s?-\\s?|\\W[A-Z]{1}\\W)');
}
 
function initSlideVariantButtons() {
    const slideDesc = document.querySelectorAll('.slider__slide > div.product__media.media--description > p');

    const variantOptonValues = Array.from(variant_selector.querySelectorAll('option')).sort((a, b) => b.value.length - a.value.length);
    const variantOptionsRegexString = variantOptonValues.map((option) => '(' + variantRegexString(option.value) + ')').join('|');
    const variantRegex = new RegExp(variantOptionsRegexString, 'g');

    slideDesc.forEach((descElement) => {
        descElement.innerHTML = descElement.innerHTML.replace(variantRegex, (match) => {
            const matchRegexString = variantRegexString(match);
            const matchRegex = new RegExp(matchRegexString);

            const optionValue = variantOptonValues.find((option) => matchRegex.test(option.value))?.value;

            if (optionValue) {
                return `<button class="image-alt-variant-button" data-option-value="${optionValue}" onclick="onClickSlideDescButton(event)">${match}</button>`;
            }
            else {
                return match;
            }
        });
    });
}

/* BOGOS Upsell */

// Update select variant in upsell app
function updateBogosUpsell() {
    const variantId = getURLParams('variant');
    document.querySelector(`.bogos-fbt-product-item-select-variant[data-product-id="${meta.product.id}"] li[value="${variantId}"`)?.click();
}

//register event callbacks

elements_to_callbacks.push({"event_type":"click","element_selector":"img[data-variant-id]", callback: updateSelector});
elements_to_callbacks.push({"event_type":"click","element_selector":"img[data-variant-id]", callback: highlightCurrentSwatch});    
elements_to_callbacks.push({"event_type":"click","element_selector":"img[data-variant-id]", callback: updateATCButtonText});    
elements_to_callbacks.push({"event_type":"click","element_selector":"img[data-variant-id]", callback: showOOSForm}); 
elements_to_callbacks.push({"event_type":"click","element_selector":"img[data-variant-id]", callback: updateSalePrice}); 
elements_to_callbacks.push({"event_type":"click","element_selector":"img[data-variant-id]", callback:handleClearanceLIP});
elements_to_callbacks.push({"event_type":"click","element_selector":"img[data-variant-id]", callback:displayHighReturnBanner});
//elements_to_callbacks.push({"event_type":"click","element_selector":"img[data-variant-id]", callback:displaySpecialClearanceVerbiage});
elements_to_callbacks.push({"event_type":"click","element_selector":"a[data-color-group]", callback:colorGroupHandler});
elements_to_callbacks.push({"event_type":"click","element_selector":"a[data-color-group]", callback:hideShowClearanceSection});
elements_to_callbacks.push({"event_type":"click","element_selector":"img[data-variant-id]", callback: updateStickyATC});
elements_to_callbacks.push({"event_type":"click","element_selector":"img[data-variant-id]", callback: updateBogosUpsell});

//elements_to_callbacks.push({"event_type":"click","element_selector":"#clearance-swatches img[data-variant-id]", callback:displaySelectedClearancePrice});


elements_to_callbacks.push({"event_type":"change","element_selector":`select[name="options[Color]"]`, callback:highlightCurrentSwatch});
elements_to_callbacks.push({"event_type":"change","element_selector":`select[name="options[Color]"]`, callback:updateATCButtonText}); 
elements_to_callbacks.push({"event_type":"change","element_selector":`select[name="options[Color]"]`, callback:showOOSForm});
elements_to_callbacks.push({"event_type":"change","element_selector":`select[name="options[Color]"]`, callback:display30PercentSaleMessage});
elements_to_callbacks.push({"event_type":"change","element_selector":`select[name="options[Color]"]`, callback:updateSalePrice});
elements_to_callbacks.push({"event_type":"change","element_selector":`select[name="options[Color]"]`, callback:handleClearanceLIP});
elements_to_callbacks.push({"event_type":"change","element_selector":`select[name="options[Color]"]`, callback:displayHighReturnBanner});
elements_to_callbacks.push({"event_type":"change", "element_selector":`select[name="options[Color]"]`, callback: updateStickyATC});
elements_to_callbacks.push({"event_type":"change", "element_selector":`select[name="options[Color]"]`, callback: updateBogosUpsell});

// elements_to_callbacks.push({"event_type":"change","element_selector":`select[name="options[Color]"]`, callback:displaySpecialClearanceVerbiage});
//elements_to_callbacks.push({"event_type":"change","element_selector":`select[name="options[Color]"]`, callback:displaySelectedClearancePrice});


elements_to_callbacks.push({"event_type":"slideChanged","element_selector":`slider-component`, callback:handleSlideChange});





//run on initial pageload 
initSwatchDividers();
initClearanceSection();
initBlendSection();
createColorGroups();
attachSoldOutMarkers();
initStickyATC();
detectSingleVariants();
window.addEventListener('load', updateBogosUpsell, {once: true});

const init_floating_atc = isElementLoaded('#floating-atc').then(() =>{    
  // floating_atc = document.querySelector('#floating-atc');
  
  // updateFloatingATC();  
});


function printDebug(a){
  
  let dbi = document.querySelector('#debug-info div');
  if(dbi){
        a.toString();
        dbi.insertAdjacentHTML('afterbegin',`<div>${a}<div>`);
  }

}

if(initial_swatch){
    highlightCurrentSwatch(initial_swatch);
    updateATCButtonText(initial_swatch);
    showOOSForm(initial_swatch);
    display30PercentSaleMessage(initial_swatch)
    displayClearancePriceRange();
    //displaySelectedClearancePrice(initial_swatch);
    handleClearanceLIP(initial_swatch);
    displayHighReturnBanner(initial_swatch);
    displaySpecialClearanceVerbiage(initial_swatch);
    updateStickyATC(initial_swatch);
}else{
    const chooseAColor = document.querySelectorAll('.product-form__input.product-form__input--dropdown label')[0].innerText.toLowerCase()  === 'color';
  
    //disable the cart button on initial load and update button only on those items with a 'choose a color' option
    if(chooseAColor){
      disableATCButton();      
      updateATCButtonText(initial_swatch,null,'Choose a color');
      updateStickyATCChooseColor();
    }
    else {
      activateStickyATCButton();
    }
  
    initDropDownSelector();

    //displayMainPriceRange();
    displayClearancePriceRange();
    display30PercentSaleMessage();

 
}
//hideShowColorDividers();

if (document.querySelector('slider-component[data-gallery-preview-type="carousel"]')) {
    initSlideVariantButtons();
}
